var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStatusError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.48 4.47 0 9.99 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 9.99 20C4.47 20 0 15.52 0 10ZM11 6C11 5.45 10.55 5 9.99997 5C9.44997 5 8.99997 5.45 8.99997 6V10C8.99997 10.55 9.44997 11 9.99997 11C10.55 11 11 10.55 11 10V6ZM10.0001 18C5.58005 18 2.00005 14.42 2.00005 10C2.00005 5.58 5.58005 2 10.0001 2C14.4201 2 18.0001 5.58 18.0001 10C18.0001 14.42 14.4201 18 10.0001 18ZM8.99997 13V15H11V13H8.99997Z",
    fill: "#A72E12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatusError);
export default __webpack_public_path__ + "static/media/icon-status-error.76478119bb50409d35ff856e4dfcda42.svg";
export { ForwardRef as ReactComponent };